import { ReactNode } from 'react'

import styles from './PerSalePointContainer.module.scss';


type Props = {
  children: ReactNode
}

export const PerSalePointContainer = ({ children }: Props) => {
  return (
    <div className={styles.root}>{children}</div>
  )
}
